import { Event } from '../Event'
import { Identity } from '../../constants'
import { SellableProperties } from './types'

export interface GuestCheckoutStartedEventProperties {
  products: (SellableProperties & { quantity: number })[]
  total: string
}

export class GuestCheckoutStartedEvent extends Event<GuestCheckoutStartedEventProperties> {
  static displayName = 'Guest Checkout Started'

  static allowedIdentities = [Identity.Guest]
}
